// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d855a71b","455":"3ff9cf65","977":"c3d99690"}[chunkId] + ".chunk.js";
};